import { Area, AudioRegion, AudioRegionData } from "../../types/AudioRegions";
import { OnrideMusic } from "../music/OnrideMusic";
import { RegionMusic } from "../music/RegionMusic";
import { SoundEffect } from "../music/SoundEffect";
import { audio_engine } from "../core/AudioEngine";
import { coreDataStore } from "../../helper/CoreDataStorage";

export const playConnectionEffect = () => {
  new SoundEffect("start.mp3");
};

export const playSoundEffect = (url: string) => {
  new SoundEffect(url);
};

export const playOnboardMusic = (url: string) => {
  audio_engine.region_sounds.map((rs) => rs.stopClean());
  new OnrideMusic(url);
};

export const play3DSoundEffect = (
  uuid: string,
  url: string,
  x: number,
  y: number,
  z: number,
) => {
  new SoundEffect(url).applyOrientation(uuid, x, y, z);
};

export const getHighestPriorityArea = (): Area | null => {
  const areas = coreDataStore.current_areas;

  if (!areas.length) return null;

  return areas.reduce((highest, current) =>
    current.priority > highest.priority ? current : highest,
  );
};

const getRegionSource = (areaName: string): string | null => {
  const rg_data = coreDataStore.core_data?.areas as AudioRegion[];

  const region = rg_data.find((rg: AudioRegion) => rg.id === areaName);

  return region ? region.source : null;
};

export const refreshRegionMusic = () => {
  const highestArea = getHighestPriorityArea();
  console.log("Current Region: " + highestArea?.name);
  if (!highestArea) {
    if (audio_engine.current_region_music) {
      audio_engine.current_region_music.stopClean();
      audio_engine.current_region_music = null;
      audio_engine.current_region_name = null;
    }

    return;
  }

  if (audio_engine.current_region_name === highestArea.name) {
    return;
  }
  if (audio_engine.current_region_music) {
    audio_engine.current_region_music.stopClean();
  }
  const source = getRegionSource(highestArea.name);

  if (!source) return;

  if (audio_engine.onride_sound) return;

  const music = new RegionMusic(source, highestArea.name, highestArea.priority);

  audio_engine.current_region_music = music;
  audio_engine.current_region_name = highestArea.name;
};
